module.exports = __webpack_public_path__ + "img/bg_welcome_2.a53acfd5.png";